module.exports = {"shakaConfig":{"streaming":{"ignoreTextStreamFailures":true},"abr":{"enabled":true,"restrictions":{}}},"forceRedirectExternalStreams":false}


//////////////////
// WEBPACK FOOTER
// ./default-config.json
// module id = 6
// module chunks = 0


// WEBPACK FOOTER //
// dash/default-config.json